import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchCompanyBranchesDropdown = createAsyncThunk(
  "equipment/fetchCompanyBranchesDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getCompanyBranchesDropdown();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch company branches dropdown");
    }
  }
);

export const fetchEquipmentData = createAsyncThunk(
  "equipment/fetchEquipmentData",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentData(params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipments");
    }
  }
);

export const fetchEquipmentOverview = createAsyncThunk(
  "equipment/fetchEquipmentOverview",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentOverview();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment overview");
    }
  }
);

export const fetchEquipmentTypesDropdown = createAsyncThunk(
  "equipment/fetchEquipmentTypesDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentTypesDropdown();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment types dropdown");
    }
  }
);

export const fetchEquipmentManufacturersDropdown = createAsyncThunk(
  "equipment/fetchEquipmentManufacturersDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentManufacturersDropdown();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment manufacturers dropdown");
    }
  }
);

export const fetchEquipmentModelsDropdown = createAsyncThunk(
  "equipment/fetchEquipmentModelsDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentModelsDropdown();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment models dropdown");
    }
  }
);

export const fetchEquipmentVendorsDropdown = createAsyncThunk(
  "equipment/fetchEquipmentVendorsDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentVendorsDropdown();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment vendors dropdown");
    }
  }
);

export const fetchEquipmentDetail = createAsyncThunk(
  "equipment/fetchEquipmentDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentDetail(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment detail");
    }
  }
);

export const fetchEquipmentServiceDetail = createAsyncThunk(
  "equipment/fetchEquipmentServiceDetail",
  async ({ equipmentId, serviceId }, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentServiceDetail(
        equipmentId,
        serviceId,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment service detail");
    }
  }
);

export const fetchEquipmentServiceRecords = createAsyncThunk(
  "equipment/fetchEquipmentServiceRecords",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentServices(params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment service records");
    }
  }
);

export const fetchEquipmentInstallments = createAsyncThunk(
  "equipment/fetchEquipmentInstallments",
  async (equipmentId, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentInstallments(equipmentId);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment installments");
    }
  }
);

export const createEquipmentInstallment = createAsyncThunk(
  "equipment/createEquipmentInstallment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiService.createEquipmentInstallment(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to create equipment installment");
    }
  }
);

export const updateEquipmentGeneralInfo = createAsyncThunk(
  "equipment/updateEquipmentGeneralInfo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiService.updateEquipmentGeneralInfo(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to update equipment general information");
    }
  }
);

export const updateEquipmentPurchaseInfo = createAsyncThunk(
  "equipment/updateEquipmentPurchaseInfo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiService.updateEquipmentPurchaseInfo(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to update equipment purchase information");
    }
  }
);

export const fetchEquipmentDistanceSummary = createAsyncThunk(
  "equipment/fetchEquipmentDistanceSummary",
  async (equipmentId, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentDistanceSummary(equipmentId);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment distance summary");
    }
  }
);

export const fetchEquipmentTrips = createAsyncThunk(
  "equipment/fetchEquipmentTrips",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentTrips(params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment trips");
    }
  }
);

export const fetchEquipmentHistory = createAsyncThunk(
  "equipment/fetchEquipmentHistory",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentHistory(params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment history");
    }
  }
);

export const commentOnEquipment = createAsyncThunk(
  "equipment/commentOnEquipment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.commentOnEquipment(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to comment on equipment");
    }
  }
);

export const createEquipment = createAsyncThunk(
  "equipment/createEquipment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiService.createEquipment(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to create equipment");
    }
  }
);

export const fetchEquipmentAssignmentHistory = createAsyncThunk(
  "equipment/fetchEquipmentAssignmentHistory",
  async (equipmentId, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentAssignmentHistory(equipmentId);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment assignment history");
    }
  }
);

export const attachEquipmentTyres = createAsyncThunk(
  "equipment/attachEquipmentTyres",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiService.attachVehicleTyres(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to link equipment tyres");
    }
  }
);

export const fetchEquipmentDropdown = createAsyncThunk(
  "equipment/fetchEquipmentDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getEquipmentDropdown();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch equipment dropdown");
    }
  }
);

export const deleteEquipment = createAsyncThunk(
  "equipment/deleteEquipment",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.deleteEquipment(id);
      return { ...response, deletedId: id };
    } catch (error) {
      return rejectWithValue(error || "Failed to delete equipment");
    }
  }
);

const initialState = {
  data: [],
  loading: false,
  error: null,
  currentPage: 1,
  totalPages: 1,
  totalRecords: 0,
  meta: {},
  createEquipmentLoading: false,
  createEquipmentError: null,
  createdEquipmentData: null,
  deleteEquipmentLoading: false,
  deleteEquipmentError: null,
  equipmentDetailData: null,
  equipmentDetailLoading: false,
  equipmentDetailError: null,
  equipmentServiceRecordsData: [],
  equipmentServiceRecordsLoading: false,
  equipmentServiceRecordsError: null,
  equipmentServiceRecordsMeta: {},
  equipmentInstallmentsData: [],
  equipmentInstallmentsLoading: false,
  equipmentInstallmentsError: null,
  createEquipmentInstallmentLoading: false,
  createEquipmentInstallmentError: null,
  updateEquipmentGeneralInfoData: null,
  updateEquipmentGeneralInfoLoading: false,
  updateEquipmentGeneralInfoError: null,
  updateEquipmentPurchaseInfoData: null,
  updateEquipmentPurchaseInfoLoading: false,
  updateEquipmentPurchaseInfoError: null,
  equipmentDistanceSummaryData: null,
  equipmentDistanceSummaryLoading: false,
  equipmentDistanceSummaryError: null,
  equipmentTripsData: [],
  equipmentTripsLoading: false,
  equipmentTripsError: null,
  equipmentTripsMeta: {},
  equipmentHistoryData: [],
  equipmentHistoryLoading: false,
  equipmentHistoryError: null,
  equipmentAssignmentHistoryData: null,
  equipmentAssignmentHistoryLoading: false,
  equipmentAssignmentHistoryError: null,
  attachEquipmentTyresLoading: false,
  attachEquipmentTyresError: null,
  commentOnEquipmentData: null,
  commentOnEquipmentLoading: false,
  commentOnEquipmentError: null,
  companyBranchesDropdownData: [],
  equipmentTypesDropdownData: [],
  equipmentManufacturersDropdownData: [],
  equipmentModelsDropdownData: [],
  equipmentVendorsDropdownData: [],
  equipmentDropdownData: [],
  dropdownLoadingCount: 0,
  dropdownError: null,
  equipmentOverviewData: null,
  equipmentOverviewLoading: false,
  equipmentOverviewError: null,
};

const equipmentSlice = createSlice({
  name: "equipment",
  initialState,
  reducers: {
    clearEquipmentError: (state) => {
      state.error = null;
      state.createEquipmentError = null;
      state.updateEquipmentGeneralInfoError = null;
      state.updateEquipmentPurchaseInfoError = null;
      state.dropdownError = null;
    },
    clearCreateEquipmentState: (state) => {
      state.createEquipmentLoading = false;
      state.createEquipmentError = null;
      state.createdEquipmentData = null;
    },
    clearEquipmentDetailState: (state) => {
      state.equipmentDetailData = null;
      state.equipmentDetailLoading = false;
      state.equipmentDetailError = null;
      state.equipmentServiceRecordsData = [];
      state.equipmentServiceRecordsLoading = false;
      state.equipmentServiceRecordsError = null;
      state.equipmentServiceRecordsMeta = {};
      state.equipmentInstallmentsData = [];
      state.equipmentInstallmentsLoading = false;
      state.equipmentInstallmentsError = null;
      state.createEquipmentInstallmentLoading = false;
      state.createEquipmentInstallmentError = null;
      state.updateEquipmentGeneralInfoData = null;
      state.updateEquipmentGeneralInfoLoading = false;
      state.updateEquipmentGeneralInfoError = null;
      state.updateEquipmentPurchaseInfoData = null;
      state.updateEquipmentPurchaseInfoLoading = false;
      state.updateEquipmentPurchaseInfoError = null;
      state.equipmentDistanceSummaryData = null;
      state.equipmentDistanceSummaryLoading = false;
      state.equipmentDistanceSummaryError = null;
      state.equipmentTripsData = [];
      state.equipmentTripsLoading = false;
      state.equipmentTripsError = null;
      state.equipmentTripsMeta = {};
    },
    clearEquipmentHistoryState: (state) => {
      state.equipmentHistoryData = [];
      state.equipmentHistoryLoading = false;
      state.equipmentHistoryError = null;
      state.commentOnEquipmentData = null;
      state.commentOnEquipmentLoading = false;
      state.commentOnEquipmentError = null;
    },
    clearEquipmentAssignmentHistoryState: (state) => {
      state.equipmentAssignmentHistoryData = null;
      state.equipmentAssignmentHistoryLoading = false;
      state.equipmentAssignmentHistoryError = null;
      state.attachEquipmentTyresLoading = false;
      state.attachEquipmentTyresError = null;
    },
    clearEquipmentDropdowns: (state) => {
      state.companyBranchesDropdownData = [];
      state.equipmentTypesDropdownData = [];
      state.equipmentManufacturersDropdownData = [];
      state.equipmentModelsDropdownData = [];
      state.equipmentVendorsDropdownData = [];
      state.equipmentDropdownData = [];
      state.dropdownLoadingCount = 0;
      state.dropdownError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEquipmentData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEquipmentData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data?.results || [];
        state.meta = action.payload?.data?.meta || {};
        state.totalRecords = action.payload?.data?.meta?.totalItems || 0;
        state.totalPages = action.payload?.data?.meta?.totalPages || 1;
        state.error = null;
      })
      .addCase(fetchEquipmentData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = [];
      })
      .addCase(fetchEquipmentOverview.pending, (state) => {
        state.equipmentOverviewLoading = true;
        state.equipmentOverviewError = null;
      })
      .addCase(fetchEquipmentOverview.fulfilled, (state, action) => {
        state.equipmentOverviewLoading = false;
        state.equipmentOverviewData = action.payload?.data || null;
        state.equipmentOverviewError = null;
      })
      .addCase(fetchEquipmentOverview.rejected, (state, action) => {
        state.equipmentOverviewLoading = false;
        state.equipmentOverviewData = null;
        state.equipmentOverviewError = action.payload;
      })
      .addCase(createEquipment.pending, (state) => {
        state.createEquipmentLoading = true;
        state.createEquipmentError = null;
      })
      .addCase(createEquipment.fulfilled, (state, action) => {
        state.createEquipmentLoading = false;
        state.createEquipmentError = null;
        state.createdEquipmentData = action.payload?.data || action.payload || null;
      })
      .addCase(createEquipment.rejected, (state, action) => {
        state.createEquipmentLoading = false;
        state.createEquipmentError = action.payload;
      })
      .addCase(deleteEquipment.pending, (state) => {
        state.deleteEquipmentLoading = true;
        state.deleteEquipmentError = null;
      })
      .addCase(deleteEquipment.fulfilled, (state, action) => {
        state.deleteEquipmentLoading = false;
        state.deleteEquipmentError = null;
        state.data = state.data.filter(
          (row) => Number(row?.id) !== Number(action.payload?.deletedId)
        );
      })
      .addCase(deleteEquipment.rejected, (state, action) => {
        state.deleteEquipmentLoading = false;
        state.deleteEquipmentError = action.payload;
      })
      .addCase(fetchEquipmentDetail.pending, (state) => {
        state.equipmentDetailLoading = true;
        state.equipmentDetailError = null;
      })
      .addCase(fetchEquipmentDetail.fulfilled, (state, action) => {
        state.equipmentDetailLoading = false;
        state.equipmentDetailData = action.payload?.data || action.payload || null;
        state.equipmentDetailError = null;
      })
      .addCase(fetchEquipmentDetail.rejected, (state, action) => {
        state.equipmentDetailLoading = false;
        state.equipmentDetailData = null;
        state.equipmentDetailError = action.payload;
      })
      .addCase(fetchEquipmentServiceDetail.pending, (state) => {
        state.equipmentDetailLoading = true;
        state.equipmentDetailError = null;
      })
      .addCase(fetchEquipmentServiceDetail.fulfilled, (state, action) => {
        state.equipmentDetailLoading = false;
        state.equipmentDetailData = action.payload?.data || action.payload || null;
        state.equipmentDetailError = null;
      })
      .addCase(fetchEquipmentServiceDetail.rejected, (state, action) => {
        state.equipmentDetailLoading = false;
        state.equipmentDetailData = null;
        state.equipmentDetailError = action.payload;
      })
      .addCase(fetchEquipmentServiceRecords.pending, (state) => {
        state.equipmentServiceRecordsLoading = true;
        state.equipmentServiceRecordsError = null;
      })
      .addCase(fetchEquipmentServiceRecords.fulfilled, (state, action) => {
        state.equipmentServiceRecordsLoading = false;
        state.equipmentServiceRecordsData = action.payload?.data?.results || [];
        state.equipmentServiceRecordsMeta = action.payload?.data?.meta || {};
        state.equipmentServiceRecordsError = null;
      })
      .addCase(fetchEquipmentServiceRecords.rejected, (state, action) => {
        state.equipmentServiceRecordsLoading = false;
        state.equipmentServiceRecordsData = [];
        state.equipmentServiceRecordsMeta = {};
        state.equipmentServiceRecordsError = action.payload;
      })
      .addCase(fetchEquipmentInstallments.pending, (state) => {
        state.equipmentInstallmentsLoading = true;
        state.equipmentInstallmentsError = null;
      })
      .addCase(fetchEquipmentInstallments.fulfilled, (state, action) => {
        const source = action.payload?.data;
        state.equipmentInstallmentsLoading = false;
        state.equipmentInstallmentsData = Array.isArray(source)
          ? source
          : Array.isArray(source?.results)
            ? source.results
            : [];
        state.equipmentInstallmentsError = null;
      })
      .addCase(fetchEquipmentInstallments.rejected, (state, action) => {
        state.equipmentInstallmentsLoading = false;
        state.equipmentInstallmentsData = [];
        state.equipmentInstallmentsError = action.payload;
      })
      .addCase(createEquipmentInstallment.pending, (state) => {
        state.createEquipmentInstallmentLoading = true;
        state.createEquipmentInstallmentError = null;
      })
      .addCase(createEquipmentInstallment.fulfilled, (state) => {
        state.createEquipmentInstallmentLoading = false;
        state.createEquipmentInstallmentError = null;
      })
      .addCase(createEquipmentInstallment.rejected, (state, action) => {
        state.createEquipmentInstallmentLoading = false;
        state.createEquipmentInstallmentError = action.payload;
      })
      .addCase(updateEquipmentGeneralInfo.pending, (state) => {
        state.updateEquipmentGeneralInfoLoading = true;
        state.updateEquipmentGeneralInfoError = null;
      })
      .addCase(updateEquipmentGeneralInfo.fulfilled, (state, action) => {
        state.updateEquipmentGeneralInfoLoading = false;
        state.updateEquipmentGeneralInfoData = action.payload?.data || action.payload || null;
        state.updateEquipmentGeneralInfoError = null;
      })
      .addCase(updateEquipmentGeneralInfo.rejected, (state, action) => {
        state.updateEquipmentGeneralInfoLoading = false;
        state.updateEquipmentGeneralInfoError = action.payload;
      })
      .addCase(updateEquipmentPurchaseInfo.pending, (state) => {
        state.updateEquipmentPurchaseInfoLoading = true;
        state.updateEquipmentPurchaseInfoError = null;
      })
      .addCase(updateEquipmentPurchaseInfo.fulfilled, (state, action) => {
        state.updateEquipmentPurchaseInfoLoading = false;
        state.updateEquipmentPurchaseInfoData = action.payload?.data || action.payload || null;
        state.updateEquipmentPurchaseInfoError = null;
      })
      .addCase(updateEquipmentPurchaseInfo.rejected, (state, action) => {
        state.updateEquipmentPurchaseInfoLoading = false;
        state.updateEquipmentPurchaseInfoError = action.payload;
      })
      .addCase(fetchEquipmentDistanceSummary.pending, (state) => {
        state.equipmentDistanceSummaryLoading = true;
        state.equipmentDistanceSummaryError = null;
      })
      .addCase(fetchEquipmentDistanceSummary.fulfilled, (state, action) => {
        state.equipmentDistanceSummaryLoading = false;
        state.equipmentDistanceSummaryData = action.payload?.data || null;
        state.equipmentDistanceSummaryError = null;
      })
      .addCase(fetchEquipmentDistanceSummary.rejected, (state, action) => {
        state.equipmentDistanceSummaryLoading = false;
        state.equipmentDistanceSummaryData = null;
        state.equipmentDistanceSummaryError = action.payload;
      })
      .addCase(fetchEquipmentTrips.pending, (state) => {
        state.equipmentTripsLoading = true;
        state.equipmentTripsError = null;
      })
      .addCase(fetchEquipmentTrips.fulfilled, (state, action) => {
        const source = action.payload?.data || {};
        state.equipmentTripsLoading = false;
        state.equipmentTripsData = Array.isArray(source)
          ? source
          : source?.results || [];
        state.equipmentTripsMeta = source?.meta || {};
        state.equipmentTripsError = null;
      })
      .addCase(fetchEquipmentTrips.rejected, (state, action) => {
        state.equipmentTripsLoading = false;
        state.equipmentTripsData = [];
        state.equipmentTripsMeta = {};
        state.equipmentTripsError = action.payload;
      })
      .addCase(fetchEquipmentHistory.pending, (state) => {
        state.equipmentHistoryLoading = true;
        state.equipmentHistoryError = null;
      })
      .addCase(fetchEquipmentHistory.fulfilled, (state, action) => {
        state.equipmentHistoryLoading = false;
        state.equipmentHistoryData = action.payload?.data || action.payload || [];
        state.equipmentHistoryError = null;
      })
      .addCase(fetchEquipmentHistory.rejected, (state, action) => {
        state.equipmentHistoryLoading = false;
        state.equipmentHistoryData = [];
        state.equipmentHistoryError = action.payload;
      })
      .addCase(fetchEquipmentAssignmentHistory.pending, (state) => {
        state.equipmentAssignmentHistoryLoading = true;
        state.equipmentAssignmentHistoryError = null;
      })
      .addCase(fetchEquipmentAssignmentHistory.fulfilled, (state, action) => {
        state.equipmentAssignmentHistoryLoading = false;
        state.equipmentAssignmentHistoryData = action.payload?.data || action.payload || null;
        state.equipmentAssignmentHistoryError = null;
      })
      .addCase(fetchEquipmentAssignmentHistory.rejected, (state, action) => {
        state.equipmentAssignmentHistoryLoading = false;
        state.equipmentAssignmentHistoryData = null;
        state.equipmentAssignmentHistoryError = action.payload;
      })
      .addCase(attachEquipmentTyres.pending, (state) => {
        state.attachEquipmentTyresLoading = true;
        state.attachEquipmentTyresError = null;
      })
      .addCase(attachEquipmentTyres.fulfilled, (state) => {
        state.attachEquipmentTyresLoading = false;
        state.attachEquipmentTyresError = null;
      })
      .addCase(attachEquipmentTyres.rejected, (state, action) => {
        state.attachEquipmentTyresLoading = false;
        state.attachEquipmentTyresError = action.payload;
      })
      .addCase(commentOnEquipment.pending, (state) => {
        state.commentOnEquipmentLoading = true;
        state.commentOnEquipmentError = null;
      })
      .addCase(commentOnEquipment.fulfilled, (state, action) => {
        state.commentOnEquipmentLoading = false;
        state.commentOnEquipmentData = action.payload?.data || action.payload || null;
        state.commentOnEquipmentError = null;
      })
      .addCase(commentOnEquipment.rejected, (state, action) => {
        state.commentOnEquipmentLoading = false;
        state.commentOnEquipmentData = null;
        state.commentOnEquipmentError = action.payload;
      })
      .addCase(fetchCompanyBranchesDropdown.fulfilled, (state, action) => {
        state.companyBranchesDropdownData =
          action.payload?.data !== undefined ? action.payload.data : action.payload || [];
      })
      .addCase(fetchEquipmentTypesDropdown.fulfilled, (state, action) => {
        state.equipmentTypesDropdownData =
          action.payload?.data !== undefined ? action.payload.data : action.payload || [];
      })
      .addCase(fetchEquipmentManufacturersDropdown.fulfilled, (state, action) => {
        state.equipmentManufacturersDropdownData =
          action.payload?.data !== undefined ? action.payload.data : action.payload || [];
      })
      .addCase(fetchEquipmentModelsDropdown.fulfilled, (state, action) => {
        state.equipmentModelsDropdownData =
          action.payload?.data !== undefined ? action.payload.data : action.payload || [];
      })
      .addCase(fetchEquipmentVendorsDropdown.fulfilled, (state, action) => {
        state.equipmentVendorsDropdownData =
          action.payload?.data !== undefined ? action.payload.data : action.payload || [];
      })
      .addCase(fetchEquipmentDropdown.fulfilled, (state, action) => {
        state.equipmentDropdownData =
          action.payload?.data !== undefined ? action.payload.data : action.payload || [];
      })
      .addMatcher(
        isAnyOf(
          fetchCompanyBranchesDropdown.pending,
          fetchEquipmentTypesDropdown.pending,
          fetchEquipmentManufacturersDropdown.pending,
          fetchEquipmentModelsDropdown.pending,
          fetchEquipmentVendorsDropdown.pending,
          fetchEquipmentDropdown.pending
        ),
        (state) => {
          state.dropdownLoadingCount += 1;
          state.dropdownError = null;
        }
      )
      .addMatcher(
        isAnyOf(
          fetchCompanyBranchesDropdown.fulfilled,
          fetchEquipmentTypesDropdown.fulfilled,
          fetchEquipmentManufacturersDropdown.fulfilled,
          fetchEquipmentModelsDropdown.fulfilled,
          fetchEquipmentVendorsDropdown.fulfilled,
          fetchEquipmentDropdown.fulfilled
        ),
        (state) => {
          state.dropdownLoadingCount = Math.max(0, state.dropdownLoadingCount - 1);
          state.dropdownError = null;
        }
      )
      .addMatcher(
        isAnyOf(
          fetchCompanyBranchesDropdown.rejected,
          fetchEquipmentTypesDropdown.rejected,
          fetchEquipmentManufacturersDropdown.rejected,
          fetchEquipmentModelsDropdown.rejected,
          fetchEquipmentVendorsDropdown.rejected,
          fetchEquipmentDropdown.rejected
        ),
        (state, action) => {
          state.dropdownLoadingCount = Math.max(0, state.dropdownLoadingCount - 1);
          state.dropdownError = action.payload;
        }
      );
  },
});

export const {
  clearEquipmentError,
  clearCreateEquipmentState,
  clearEquipmentDetailState,
  clearEquipmentHistoryState,
  clearEquipmentAssignmentHistoryState,
  clearEquipmentDropdowns,
} = equipmentSlice.actions;

export default equipmentSlice.reducer;
